import L from 'leaflet'
import Control from '../leaflet-controls/control'
import { VBtn } from 'vuetify/lib'

export default Control.extend({
  options: {
    position: 'topcenter'
  },
  onAdd: function () {
    this.options.vue.map.customControls[this.id] = this
    const defaultColor = this.options.defaultColor

    this._container = L.DomUtil.create('div', 'd-flex flex-column justify-center')

    L.DomEvent.disableClickPropagation(this._container)

    this._btn = new VBtn({
      propsData: {
        color: defaultColor,
        outlined: true,
        rounded: true,
        small: true,
      },
      computed: {
        classes () {
          return {
            'v-btn': true,
            'v-btn--absolute': this.absolute,
            'v-btn--block': this.block,
            'v-btn--bottom': this.bottom,
            'v-btn--disabled': this.disabled,
            'v-btn--is-elevated': this.isElevated,
            'v-btn--fab': this.fab,
            'v-btn--fixed': this.fixed,
            'v-btn--has-bg': this.hasBg,
            'v-btn--icon': this.icon,
            'v-btn--left': this.left,
            'v-btn--loading': this.loading,
            'v-btn--outlined': this.outlined,
            'v-btn--plain': this.plain,
            'v-btn--right': this.right,
            'v-btn--round': this.isRound,
            'v-btn--rounded': this.rounded,
            'v-btn--router': this.to,
            'v-btn--text': this.text,
            'v-btn--tile': this.tile,
            'v-btn--top': this.top,
            ...this.themeClasses,
            ...this.groupClasses,
            ...this.elevationClasses,
            ...this.sizeableClasses,
          }
        }
      }
    })

    this._btn.$slots.default = [this._btn.$createElement('span', 'Close')]
    this._btn.$vuetify = this.options.vue.$vuetify

    this._btn.$on('click', this._btnClick.bind(this))
    this._btn.$mount()

    const div = document.createElement('div')
    div.style.color = this.options.defaultColor
    div.classList.add('subtitle-2')
    div.innerText = 'To place a point, hold down the Shift and click the LMB.'

    const btnWrapper = document.createElement('div')
    btnWrapper.appendChild(this._btn.$el)
    btnWrapper.style.textAlign = 'center'

    this._container.appendChild(div)
    this._container.appendChild(btnWrapper)
    return this._container
  },
  _btnClick: function () {
    this._map.removeControl(this.options.parent)
    this.options.vue.map._container.focus()
  },
  onRemove: function () {
    this._btn.$off('click', this._btnClick)
    this._btn.$destroy()
    if (this._btn.$el && this._btn.$el.parentNode) {
      this._btn.$el.parentNode.removeChild(this._btn.$el)
    }
  }
})